import {
  ColumnType,
  ListItemText,
  TableList,
} from 'app/components/ChakraTableList';
import { ImportSongWithoutFiles } from '../types';
import { Uploaded } from './uploaded';

interface ImportSongsTableProps {
  songs: ImportSongWithoutFiles[];
}

export const columns: ColumnType[] = [
  { key: 'songTitle', name: 'Song Title' },
  {
    key: 'lyrics',
    name: 'Lyrics',
    width: '50px',
  },
  { key: 'audioTitle', name: 'Audio Title' },
  {
    key: 'uploaded',
    name: 'Uploaded',
    width: '100px',
    alignRight: true,
  },
];

export const ImportSongsTable = ({ songs }: ImportSongsTableProps) => {
  return (
    <TableList
      scrollable
      columns={columns}
      rows={songs
        .map((item) => {
          const rows = item.audios.slice(1).map((audio) => ({
            audioTitle: <ListItemText primary={audio.audioTitle} />,
            uploaded: <Uploaded songGuid={item.guid} item={audio} />,
          }));

          return [
            {
              songTitle: (
                <ListItemText primary={item.songTitle} title={item.songTitle} />
              ),
              lyrics: <Uploaded songGuid={item.guid} item={item.lyrics} />,
              audioTitle: <ListItemText primary={item.audios[0]?.audioTitle} />,
              uploaded: <Uploaded songGuid={item.guid} item={item.audios[0]} />,
            },
            ...rows,
          ];
        })
        .flat()}
    />
  );
};
